import { createApi } from '@reduxjs/toolkit/query/react';
import {
  GetParameterHistoryRequest,
  ParameterHistory,
  ParameterHistoryFromJSON,
} from 'apis/backendApi';
import { addQueryContext, WithQueryContext } from 'core/apiQueryContext';
import { apiQuery } from 'core/rtkQuery';

const parameterHistoryApiDef = createApi({
  reducerPath: 'parameterHistoryApi',
  baseQuery: apiQuery(),

  endpoints: builder => ({
    getParameterHistory: builder.query<
      ParameterHistory[],
      WithQueryContext<GetParameterHistoryRequest>
    >({
      query: ({ buCode, filter, filterValue, paramId }) => ({
        url:
          filter && (filterValue !== '' || paramId)
            ? '/parameters/v1/{buCode}/history'
            : null,
        params: {
          filter,
          filterValue,
          paramId,
        },
        pathVariables: { buCode },
      }),

      transformResponse: (json: any) => json?.map(ParameterHistoryFromJSON),
    }),
  }),
});

export const parameterHistoryApi = addQueryContext(parameterHistoryApiDef);
export const { useGetParameterHistoryQuery } = parameterHistoryApi;

export default parameterHistoryApi;
